export const PsnAlertServiceImplFactory = ({
  psnAlertRepository,
}: {
  psnAlertRepository: IPsnAlertRepository;
}) => {
  const getPsnAlertList: IGetPsnAlertList = async ({
    clinicId,
    page,
    page_size,
    date,
    consent,
    floorIds,
    pagination_flag,
    levels,
  }) => {
    try {
      const payload: IGetPsnAlertListAPIPayload = {
        clinic_id: clinicId,
        page,
        page_size,
        date,
        consent,
        floor_ids: floorIds,
        pagination_flag,
        level: levels,
      };

      const response = await psnAlertRepository.getPsnAlertList(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPsnAlertGraphDataList: IGetPsnAlertGraphDataList = async ({
    clinicId,
    residentIds,
  }) => {
    try {
      const payload: IGetPsnAlertGraphDataListAPIPayload = {
        clinic_id: clinicId,
        patient_ids: residentIds,
      };

      const response = await psnAlertRepository.getPsnAlertGraphDataList(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPsnAlertAck: IGetPsnAlertAck = async (payload) => {
    try {
      const response = await psnAlertRepository.getPsnAlertAckAPI(payload);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const addPsnAlertAck: IAddPsnAlertAck = async (payload) => {
    try {
      const response = await psnAlertRepository.addPsnAlertAckAPI({
        alert_id: payload.alertId,
        clinic_id: payload.clinicId,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const putPSNv2Review: IPutPSNv2Review = async (payload) => {
    try {
      const response = await psnAlertRepository.putPSNv2ReviewAPI({
        clinic_id: payload.clinicId,
        notification_uuid: payload.notificationUuid,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getPsnAlertList,
    getPsnAlertGraphDataList,
    getPsnAlertAck,
    addPsnAlertAck,
    putPSNv2Review,
  };
};
